export default "__VITE_ASSET__DLuK0NWY__"